@if (videos().length > 0) {
  @if (embedded()) {
    <div class="media-videos-grid media-videos-grid--embedded">
      @if (showTitle()) {
        <h4 class="media-videos-grid__title media-videos-grid__title--embedded">
          {{ titleKey() | translate }}
        </h4>
      }
      <div class="media-videos-grid__grid">
      @for (video of videos(); track video._id ?? $index) {
        @if (videoSrc(video); as src) {
          <article class="media-videos-grid__item">
            <button
              type="button"
              class="media-videos-grid__thumb"
              (click)="openVideoDialog(src)"
              [attr.aria-label]="
                videoDisplayName(video) || (titleKey() | translate)
              ">
              @if (hasVideoPoster(video)) {
                <img
                  class="media-videos-grid__poster"
                  [src]="videoPoster(video)"
                  width="160"
                  height="160"
                  alt="" />
              } @else {
                <video
                  class="media-videos-grid__poster"
                  [src]="src"
                  preload="metadata"
                  muted
                  playsinline
                  aria-hidden="true"
                  (loadedmetadata)="primeVideoFrame($event)"></video>
              }
              <span class="media-videos-grid__overlay" aria-hidden="true">
                <i class="iconsax media-videos-grid__icon" icon-name="play"></i>
              </span>
            </button>
            @if (videoDisplayName(video); as label) {
              <p class="media-videos-grid__label" [title]="label">{{ label }}</p>
            }
          </article>
        }
      }
      </div>
    </div>
  } @else {
    <section
      class="media-videos-grid"
      [attr.id]="sectionId() || null">
      @if (showTitle()) {
        <h3 class="media-videos-grid__title">{{ titleKey() | translate }}</h3>
      }

      <div class="media-videos-grid__grid">
        @for (video of videos(); track video._id ?? $index) {
          @if (videoSrc(video); as src) {
            <article class="media-videos-grid__item">
              <button
                type="button"
                class="media-videos-grid__thumb"
                (click)="openVideoDialog(src)"
                [attr.aria-label]="
                  videoDisplayName(video) || (titleKey() | translate)
                ">
                @if (hasVideoPoster(video)) {
                  <img
                    class="media-videos-grid__poster"
                    [src]="videoPoster(video)"
                    width="160"
                    height="160"
                    alt="" />
                } @else {
                  <video
                    class="media-videos-grid__poster"
                    [src]="src"
                    preload="metadata"
                    muted
                    playsinline
                    aria-hidden="true"
                    (loadedmetadata)="primeVideoFrame($event)"></video>
                }
                <span class="media-videos-grid__overlay" aria-hidden="true">
                  <i
                    class="iconsax media-videos-grid__icon"
                    icon-name="play"></i>
                </span>
              </button>
              @if (videoDisplayName(video); as label) {
                <p class="media-videos-grid__label" [title]="label">
                  {{ label }}
                </p>
              }
            </article>
          }
        }
      </div>
    </section>
  }
}
